/**
 * GiftCardCreateButton — the header button that opens the create form. Renders
 * nothing for staff who may not issue gift cards.
 */
import { useState } from 'react';

import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';

import { GiftCardCreateModal } from './GiftCardCreateModal';

export function GiftCardCreateButton() {
  const { hasPermission } = usePermissions();
  const [open, setOpen] = useState(false);

  if (!hasPermission(Permission.ISSUE_GIFT_CARDS)) return null;

  return (
    <>
      <button type="button" className="nb-btn nb-btn-primary" onClick={() => setOpen(true)}>
        Create gift card
      </button>
      {open && <GiftCardCreateModal onClose={() => setOpen(false)} />}
    </>
  );
}
